module.exports = __webpack_public_path__ + "static/media/no-image.a1f8a7b2.jpg";